import service = require("./breeze.entityManager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(CVCompetenceGroupsService.Id, CVCompetenceGroupsService);

    CVCompetenceGroupsService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

export class CVCompetenceGroupsService extends base.BaseDataService<Nema.Crew.Model.CVCompetenceGroup> implements ICVCompetenceGroupsService {

    constructor(entityManagerService: service.EntityManagerService, breeze, $log, $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id: string = "cvCompetenceGroupsService";

    protected get EntityName(): string {
        return "CVCompetenceGroup";
    }

    protected get EntitiesName(): string {
        return "CVCompetenceGroups";
    }
}

export interface ICVCompetenceGroupsService extends base.IDataService<Nema.Crew.Model.CVCompetenceGroup> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/cvcompetencegroups.dataservice.ts